module.exports = __webpack_public_path__ + "img/wc_disabled2.86a8af33.svg";